import Axios, { CancelToken } from 'axios';

export type CancelRequestFunction = (p: () => any) => unknown;

export const getAxiosCancelToken = (
  cancelRequestFn: CancelRequestFunction,
): CancelToken => {
  return new Axios.CancelToken(cancelRequestFn);
};
